import { recordOf } from '@yp/common/identity.ts';
import type { Section } from '@yp/web.app/section.ts';
import { ColorMap } from './styles.ts';

export const Sections = recordOf<Section>()({
  home: {
    label: 'Home',
    icon: 'home',
    scheme: ColorMap.Home,
    href: '/',
  },
  rsvp: {
    label: 'RSVP',
    icon: 'mail',
    scheme: ColorMap.Rsvp,
    href: '/rsvp',
  },
  mosaic: {
    label: 'Mosaic',
    icon: 'wall_art',
    scheme: ColorMap.Mosaic,
    href: '/mosaic',
    hide: true,
  },
  // crobble: {
  //   label: 'Crobble',
  //   icon: 'font_download',
  //   scheme: ColorMap.Crobble,
  //   href: '/crobble',
  //   hide: true,
  // },
});
